import React, { useState } from "react";
import {
  CancelButton,
  SubmitMapButton,
  BackArrowButton,
  CloseButton,
} from "../../button/Button";
import AddIcon from "../../../assets/icons/addEcl.svg";
import AddField from "../AddField/AddField";
import Category from "./Category";
import Currency from "./Currency";
import { CiCircleQuestion } from "react-icons/ci";
import styles from "./SubMapping.module.css";
import commonstyles from "../Forms.module.css";
import { updateFixedAssetSubMapping } from "../../../../Bookclosure/Services/ApiHandler";

export default function Submapping({ FixedAssetID, onBack, onClose, onCancel, onSubmitMapping, onMapped }) {
  const [activeTab, setActiveTab] = useState("currency");
  const [showAddFieldPopup, setShowAddFieldPopup] = useState(false);
  const [categorySubmap, setCategorySubmap] = useState([]);
  const [currencySubmap, setCurrencySubmap] = useState([]);

  const handleSubmit = async () => {
    const formattedCurrency = currencySubmap.map((item) => ({
      key: item.key,
      values: item.values
    }));

    const data = {
      blockOfAssetSubmap: formattedCurrency
    };

    try {
      const res = await updateFixedAssetSubMapping(FixedAssetID, data);
      console.log("Submapping updated", res.data);
      if (onMapped) {
        onMapped();
      } else if (onSubmitMapping) {
        onSubmitMapping();
      }
    } catch (err) {
      console.error("Error Update Submapping:", err);
    }
  };

  return (
    <>
      <div className={commonstyles.backdrop}>
        <div className={`${commonstyles.container} ${styles.mediumContainer}`}>
          <div className={styles.header}>
            <div className={styles.subheader}>
              <BackArrowButton onClick={onBack} />
              <h2 className={styles.heading}>Sub mapping</h2>
            </div>

            <div className={styles.headerRight}>
              <div
                className={styles.addSection}
                onClick={() => setShowAddFieldPopup(true)}
              >
                <img src={AddIcon} alt="Add" className={styles.addIcon} />
                <span className={styles.addField}>Add Field</span>
              </div>
              <CloseButton onClick={onClose} />
            </div>
          </div>

          <div className={styles.toggle}>
            {/* <button
              className={`${styles.toggleButton} ${
                activeTab === "category" ? styles.toggleButtonActive : ""
              }`}
              onClick={() => setActiveTab("category")}
            >
              Category
            </button> */}
            <button
              className={`${styles.toggleButton} ${
                activeTab === "currency" ? styles.toggleButtonActive : ""
              }`}
              onClick={() => setActiveTab("currency")}
            >
              Currency
            </button>
          </div>

          <div className={styles.infoBox}>
            <CiCircleQuestion className={styles.infoIcon} />
            <p className={styles.infoText}>
              You may map multiple columns to a single field, but once a column
              is mapped, it cannot be assigned to any other field.
            </p>
          </div>

          <div className={styles.content}>
            {/* {activeTab === "category" ? (
              <Category FixedAssetID={FixedAssetID} onMappingChange={setCategorySubmap} />
            ) : ( */}
              <Currency FixedAssetID={FixedAssetID} onMappingChange={setCurrencySubmap} />
            {/* )} */}
          </div>

          <div className={commonstyles.footer}>
            <CancelButton onClick={onCancel} />
            <SubmitMapButton onClick={handleSubmit} />
          </div>
        </div>
      </div>

      {showAddFieldPopup && (
        <AddField onClose={() => setShowAddFieldPopup(false)} />
      )}
    </>
  );
}
